export default __webpack_public_path__ + "static/media/sessionNotes.c24d0b8f.png";